module.exports = __webpack_public_path__ + "img/instructions_02.d9e60f45.svg";